var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status-tag"},_vm._l((_vm.list),function(item){return _c('div',{key:item.agent_id,staticClass:"tag"},[_c('span',[_vm._v(_vm._s(item.agent_name))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }